import { render, staticRenderFns } from "./eightCentresContent.vue?vue&type=template&id=416d1698&scoped=true"
import script from "./eightCentresContent.vue?vue&type=script&lang=js"
export * from "./eightCentresContent.vue?vue&type=script&lang=js"
import style0 from "./eightCentresContent.vue?vue&type=style&index=0&id=416d1698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d1698",
  null
  
)

export default component.exports